module.exports = __webpack_public_path__ + "09fe467b89e4d8fe5970042528731c3b.svg";